module.exports = __webpack_public_path__ + "static/media/previous.5310d539.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/icons/previous.svg
 ** module id = 381
 ** module chunks = 0
 **/